// CountdownTimer.js
import React, { useEffect, useState} from 'react';
import Countdown from 'react-countdown';
import { View,Text, TouchableOpacity } from "react-native";
  import { CreateResponsiveStyle } from "rn-responsive-styles";
const CountdownTimer = ({ requestOtp, isShowOtpScreen,onClickGetOtp,counterRef,screenType  }) => {
 
    const styles = useStyles();
  const [timerState, setTimeState] = useState({
    times: [
      Date.now() + 5000,
      Date.now() + 12000,
      Date.now() + 17000,
      Date.now() + 22000,
    ],
    currentTimeIndex: 0,
    currentTime: Date.now() + 60000,
  });

  const completeTime = () => {
    if (
      timerState.times.length - 1 <=
      timerState.times.indexOf(timerState.currentTime)
    )
      return;
    // move to next time
    timerState.currentTimeIndex++;
    timerState.currentTime = new Date(
      timerState.times[timerState.currentTimeIndex + 1]
    );
  };

  const timerRenderer = ({ hours, minutes, seconds, completed, api }) => {
    if (completed || isNaN(minutes)) {
      return (
        <>
        {screenType === "Login" ?  null :  <Text>{"00:00"}</Text> }
          <TouchableOpacity
          onPress={() => {
            setTimeState({
              times: [
                Date.now() + 5000,
                Date.now() + 12000,
                Date.now() + 17000,
                Date.now() + 22000,
              ],
              currentTimeIndex: 0,
              currentTime: Date.now() + 60000,
            });
            setTimeout(() => {
              api.start();
            }, 500);

            onClickGetOtp();
          }}
        >
          <Text style={[styles.resendTextStyle, { marginTop: screenType ==="Login" ? 10 : 0 }]}>
            {"Resend"}
          </Text>
        </TouchableOpacity>
        </>
      );
    }
  
    if (screenType === 'Login') {
      return (
        <>
          <Text style={{ marginTop: 10 }}>
            {seconds} Sec
          </Text>
          <View>
           
          </View>
        </>
      );
    } else {
      return (
        <>
          <Text>
            {minutes}:{seconds}
          </Text>
          <View>
            <Text style={[styles.resendTextStyle, { color: "gray" }]}>
              {"Resend"}
            </Text>
          </View>
        </>
      );
    };
  }
  useEffect(() => {
    if (requestOtp)
      setTimeState({
        times: [
          Date.now() + 5000,
          Date.now() + 12000,
          Date.now() + 17000,
          Date.now() + 22000,
        ],
        currentTimeIndex: 0,
        currentTime: Date.now() + 60000,
      })
  }, [requestOtp, isShowOtpScreen])

  return (
    <Countdown
    ref={counterRef}
    date={timerState.currentTime}
    key={timerState.currentTimeIndex}
    onComplete={completeTime}
    intervalDelay={0}
    precision={3}
    renderer={timerRenderer}
    />
  );
};

const useStyles = CreateResponsiveStyle(
  {
      timerTextStyle: {
        opacity: 0.5,
        fontFamily: "Inter",
        fontSize: 13,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 15,
        letterSpacing: 0,
        textAlign: "left",
        color: "#02122c",
      },
      resendTextStyle: {
        fontFamily: "Inter",
        fontSize: 13,
        lineHeight: 15,
        letterSpacing: 0,
        textAlign: "center",
        color: "#bd2d37",
      },
    }
      
    
  );

export default CountdownTimer;
